import React, { useEffect, useRef, useState } from 'react';
import { connect}  from 'react-redux';
import { endMyExam, saveChoice } from '../actions/index'
import NoAttemptModal from '../components/modals/NoAttemptModal';
import PreSubmitModal from './modals/PreLogout';
import './Timer.css';

let timeLeft;

const Timer = props => {
    const [time, setTime] = useState({
        displayHours: "00",
        displayMinutes: "00",
        displaySeconds: "00"
    })
    const [isOpen, setIsOpen] = useState(false)
    const [timeElapse, setTimeElapse] = useState(false)

    let timer = useRef();
    let timeoutId;

    setTimeout(() => {
        const timeSpent = localStorage.getItem('timeSpent')
        if (timeSpent >= 175 && timeSpent <= 185) {
          //if (props.totalAttempted === 0) setIsOpen(true);
            const totalAttempts = Number(localStorage.getItem('totalAttempted'));
            if (!totalAttempts || totalAttempts === 0) setIsOpen(true);
        }
    }, 3 * 60 * 1000);
    
    useEffect( () => {
        timeLeft = (props.durationInMinutes * 60) - props.timeSpentInSeconds;
        localStorage.setItem('timeLeft', timeLeft);
    },[])

    const toggle = () => {
        setIsOpen(false);
    }
    
    const startTimer = () => {
        timer = setInterval(() => {
            const shouldCount = localStorage.getItem('shouldCount')
            if (shouldCount === 'false') return;
            timeLeft = timeLeft -1;
            localStorage.setItem('timeLeft', timeLeft);

            // if time has elapsed, show modal then log candidate out
            if (timeLeft < 0) {
                setTimeElapse(true);
                const responses = JSON.parse(localStorage.getItem('request'));
                const timeSpent = Number(localStorage.getItem('timeSpent'));
                if (Object.keys(responses).length > 0) {
                    props.saveChoice(props.candidateId, {responses, timeSpent});
                    localStorage.removeItem('currentSubject');
                    localStorage.removeItem('shouldCount');
                }

                timeoutId = setTimeout(() => {
                    setTimeElapse(false)
                    props.endMyExam(props.candidateId, timeSpent);
                }, 4000);
                // localStorage.clear();
                return;
            }


            const hours = Math.floor(timeLeft % (60 * 60 * 24) / (60 * 60) );
            const minutes = Math.floor(timeLeft % (60 * 60) / 60 );
            const seconds = Math.floor(timeLeft % 60);

            const formatMinutes = minutes < 10 ? "0" + minutes : minutes;
            const formatSeconds = seconds < 10 ? "0" + seconds : seconds;
            const formatHours = hours < 10 ? "0" + hours : hours;
            
            setTime({
                displayHours: formatHours, 
                displayMinutes: formatMinutes, 
                displaySeconds: formatSeconds
            })

        }, 1000);
    }

    useEffect( () => {
        startTimer();
        return () => {
            clearTimeout(timeoutId);
            clearInterval(timer);
        }
    },[timer])
    
    return (
        <React.Fragment>
            <NoAttemptModal isOpen={isOpen} toggle={toggle} />
            <PreSubmitModal isOpen={timeElapse} />
            <section className="mx-auto timer">
                <div className="minutes">
                    {time.displayHours }
                    <div className="text-sm label minSec">hours</div>
                </div>
                <span className="landing-snug">:</span>
                <div className="minutes">
                    { time.displayMinutes }
                    <div className="text-sm label minSec">minutes</div>
                </div>
                <span className="landing-snug">:</span>
                <div className="mr-2 seconds">
                    { time.displaySeconds }
                    <div className="text-sm label minSec">seconds</div>
                </div>
            </section>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return { totalAttempted: state.auth.user.data.totalAttempted}
}

export default connect(mapStateToProps, {endMyExam, saveChoice})(Timer);